module.exports = __webpack_public_path__ + "img/reg-compliance.85ce4ef5.svg";